// Port web de expo-haptics.
//
// L'API publique reproduit volontairement celle d'expo-haptics (mêmes noms,
// mêmes enums, mêmes signatures asynchrones) : les 28 fichiers appelants du
// Lot 6 n'ont alors qu'un chemin d'import à changer —
//   -import * as Haptics from "expo-haptics";
//   +import * as Haptics from "@/shared/platform/haptics";
//
// ⚠️ COUVERTURE RÉELLE, à connaître avant de compter dessus :
//   • Android/Chrome   → `navigator.vibrate` fonctionne.
//   • iOS Safari       → l'API n'existe pas. AUCUN retour haptique, jamais.
//   • Desktop          → présente sur Chrome mais sans matériel : no-op.
//
// Autrement dit, sur une bonne moitié du parc l'appel ne fait rien. Le retour
// haptique ne doit donc JAMAIS être le seul accusé de réception d'une action :
// tout geste confirmé par une vibration doit aussi l'être visuellement. C'était
// déjà une bonne pratique en natif, ça devient une contrainte ici.
//
// Les durées sont choisies pour approcher la sémantique iOS d'origine : un
// impact est une secousse unique, une notification un motif reconnaissable.

export enum ImpactFeedbackStyle {
  Light = "light",
  Medium = "medium",
  Heavy = "heavy",
}

export enum NotificationFeedbackType {
  Success = "success",
  Warning = "warning",
  Error = "error",
}

const IMPACT_MS: Record<ImpactFeedbackStyle, number> = {
  [ImpactFeedbackStyle.Light]: 10,
  [ImpactFeedbackStyle.Medium]: 20,
  [ImpactFeedbackStyle.Heavy]: 35,
};

// Motifs [vibration, pause, vibration…] — la structure porte le sens, puisque
// le web n'a pas d'intensité, seulement de la durée.
const NOTIFICATION_PATTERN: Record<NotificationFeedbackType, number | number[]> = {
  [NotificationFeedbackType.Success]: 15,
  [NotificationFeedbackType.Warning]: [20, 60, 20],
  [NotificationFeedbackType.Error]: [35, 60, 35, 60, 35],
};

function vibrate(pattern: number | number[]): void {
  // `vibrate` jette dans certains contextes (iframe sans permission, page non
  // activée par l'utilisateur). Un retour haptique raté ne doit jamais casser
  // le flux appelant.
  try {
    navigator.vibrate?.(pattern);
  } catch {
    /* no-op */
  }
}

export async function impactAsync(
  style: ImpactFeedbackStyle = ImpactFeedbackStyle.Medium,
): Promise<void> {
  vibrate(IMPACT_MS[style]);
}

export async function notificationAsync(
  type: NotificationFeedbackType = NotificationFeedbackType.Success,
): Promise<void> {
  vibrate(NOTIFICATION_PATTERN[type]);
}

export async function selectionAsync(): Promise<void> {
  // La sélection est le retour le plus discret du vocabulaire iOS.
  vibrate(5);
}
